import React from 'react';

export default function withCellData(WrappedComponent) {
    return function Wrapped({ cell: { value } }) {
        return <WrappedComponent {...value} />;
    };
}
